export default function Logo()
{
  return <a href="https://www.51room.com"><img src="/logo-100x18.png" alt="logo" /></a>
}
